import React from 'react';
import { ButtonWrapper, HeadingWrapper, Main, BodyWrapper } from '../../ErrorComponent/style';
import { Link } from '@lendi-ui/typography';
export var FatalError = function (_a) {
    var onRetry = _a.onRetry;
    return (React.createElement(Main, null,
        React.createElement(HeadingWrapper, { size: "md", color: "shade.700", mb: "xs", mt: "md" }, "Something went wrong."),
        React.createElement(BodyWrapper, { size: "md", color: "shade.700", mb: "md", mx: "xl" },
            "Chat did not work, please try again or let us know\u00A0",
            React.createElement(Link, { "data-testid": "contact-us", href: "/contactus" }, "here")),
        React.createElement(ButtonWrapper, { variant: "primary", onClick: onRetry }, "TRY AGAIN")));
};
//# sourceMappingURL=index.js.map